<template>
  <v-container>
    <v-card
      class="align-center"
      width="500"
      height="100%"
      color="messageBubble"
      elevation="0"
    >
      <v-row justify="start" no-gutters dense>
        <v-col sm="6">
          <v-btn x-small outlined color="cleed_blue">
            <b>{{ message.message || "grid " }}</b>
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense class="ma-2 mb-4" justify="start" align="center">
        <v-col
          v-for="(url, index) in message.grid.values"
          :key="index"
          cols="6"
          lg="4"
        >
          <v-img :src="url.picture_url" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Chat_grid",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  created() {},
  methods: {},
};
</script>
<style scoped></style>
